import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "uncheck",
  "use": "uncheck-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"uncheck\"><defs><style></style></defs><path d=\"M0 0h1024v1024H0z\" fill=\"#D8D8D8\" fill-opacity=\"0\" /><path d=\"M512 896c-213.333 0-384-170.667-384-384s170.667-384 384-384 384 170.667 384 384-170.667 384-384 384zm0-704c-174.933 0-320 145.067-320 320s145.067 320 320 320 320-145.067 320-320-145.067-320-320-320z\" fill=\"#C0C0CC\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol